import type { ZudokuConfig } from "zudoku";
import apiJson from "./apis.json";

type APIs = ZudokuConfig["apis"];

export const apis: APIs = Object.values(apiJson) as APIs;
